import React from 'react'
import { Columns } from 'src/components'
import { BreadcrumbsContext } from 'src/contexts'
import BreadcrumbItem from '../BreadcrumbItem'
import styles from './Breadcrumbs.scss'

/**
 * A breadcrumbs component to display the current route hierarchy.
 */
const Breadcrumbs = () => {
  const { breadcrumbs } = BreadcrumbsContext.use()
  return (
    <Columns className={styles.container} layout="auto" align="center">
      {breadcrumbs.map((breadcrumb, index) => (
        <BreadcrumbItem key={breadcrumb.to} {...breadcrumb} isLastItem={index === breadcrumbs.length - 1} />
      ))}
    </Columns>
  )
}

export default Breadcrumbs
